import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { ClaimService } from '@lsq-frontend/common-ui';
import { environment } from '@lsq-frontend/fasttrack-shared/environment';
import { Prospect } from '@lsq-frontend/remote-services/ar-app';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { DrApplicationService } from '@lsqlabs/dr-application-shared';

@Injectable({ providedIn: 'root' })
export class DocumentsService {
    public documentsClaim$ = this._claimService.isOn(DashboardClaim.ViewDocuments);
    constructor(
        private _userService: UserService,
        private _httpClient: HttpClient,
        private _arService: DrApplicationService,
        private _claimService: ClaimService
    ) {}
    public async fetchProspectData() {
        let isOn;
        this.documentsClaim$.subscribe((value) => {
            isOn = value;
        });
        if (isOn) {
            let companyKey;
            this._userService.user$.subscribe(async (user) => {
                companyKey = user.currentCompany.companyKey;
            });

            try {
                const getProspect = this._httpClient.get(
                    `${environment.httpApiServiceNameUrlMap.arApp}/v1/prospectData/ByCompanyKeyAndSchemaType?company_key=${companyKey}&schema_type=${Prospect.SchemaTypeEnum.DocumentCenter}`
                );

                const prospectData: any = await getProspect.toPromise();

                if (!prospectData) {
                    return;
                }
                this._arService.setProspect(prospectData);
                const getProspectSchema = this._httpClient.get(
                    `${environment.httpApiServiceNameUrlMap.arApp}/v1/prospectSchema?id=${prospectData.prospectSchemaId}`
                );
                const schemaData = await getProspectSchema.toPromise();
                this._arService.setProspectSchema(schemaData[0]);
                this._arService.getTotalOpenStageCount();
            } catch (e) {}
        }
    }
}
